import appStorage from '../storage/appStorage'
import { osFetch } from '../util/fetch'

export const getWebSocketToken = async (orgId) => {
  // orgId will be undefined for customers and this is acceptable. It is only really used to determine which orgId to
  // use in cases where the Pro user has access to multiple orgs
  const response = await osFetch(`${window.API_ROOT}/api/websocket/get_ws_token/`, {
    method: 'POST',
    body: JSON.stringify({ org_id: orgId }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + appStorage.getToken(),
    },
  })

  if (!response.ok) {
    let errorMessage = 'Failed to get websocket token'
    try {
      const errorData = await response.json()
      errorMessage = errorData.message || errorData.error_msg || errorMessage
    } catch (e) {
      errorMessage = response.statusText || errorMessage
    }

    const error = new Error(errorMessage)
    error.status = response.status
    throw error
  }

  const data = await response.json()
  let tokenData = data.token
  // appStorage.setItem('webSocketToken', tokenData)
  return tokenData
}
